import { render, staticRenderFns } from "./MailsModal.vue?vue&type=template&id=5357d836&scoped=true"
import script from "./MailsModal.vue?vue&type=script&lang=js"
export * from "./MailsModal.vue?vue&type=script&lang=js"
import style0 from "./MailsModal.vue?vue&type=style&index=0&id=5357d836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357d836",
  null
  
)

export default component.exports